
import Vue from "vue";
import FilterModel from "@/models/FilterModel";
import Component from "vue-class-component";
import UrgencyModel from "@/models/UrgencyModel";
import CategoryModel from "@/models/CategoryModel";
import api from "@/api";
import { UserModule } from "@/store/modules/user";
// import moment from "moment";
@Component({
    components: {},
})
export default class FilterComponent extends Vue {
    mounted() {
        this.loadUrgency();
        this.loadCateogry();
        // this.filter.datestart = moment().format("YYYY-MM-DD");
        // this.filter.dateend = moment().format("YYYY-MM-DD");
    }
    activeShow: boolean = false;

    options = [
        { value: null, text: "Sort By", notEnabled: true },
        { value: "oldest", text: "Oldest" },
        { value: "latest", text: "Latest" },
    ];

    listUrgency: { value: string | null; text: string | null }[] = [];
    filter: FilterModel = new FilterModel();
    listCategory: CategoryModel[] = [];

    userDetail = UserModule.userDetail;

    loadCateogry() {
        return new Promise((resolve, reject) => {
            // if(this.userDetail.accessgroup["name"] === "User"){
            //   api.options
            //     .getCategories()
            //     .then((response) => {
            //       if (response.data.code === 200) {
            //         this.listCategory = [...response.data.data];
            //         resolve(response);
            //       }
            //     })
            //     .catch((err) => {
            //       reject(new Error(err));
            //     });
            //   }else{
            api.options
                .getCategories2()
                .then((response) => {
                    if (response.data.code === 200) {
                        this.listCategory = [...response.data.data].map(
                            (item) => {
                                return {
                                    ...item,
                                    id: item.id,
                                    title: item.name,
                                };
                            }
                        );
                        resolve(response);
                    }
                })
                .catch((err) => {
                    reject(new Error(err));
                });
            // }
        });
    }
    loadUrgency() {
        this.listUrgency = [];
        this.listUrgency.push({ value: null, text: "Urgency Level" });
        return new Promise((resolve, reject) => {
            api.options
                .getUrgencyLevel()
                .then((response) => {
                    if (response.data.code === 200) {
                        const result = response.data.data as UrgencyModel[];
                        result.forEach((element) => {
                            this.listUrgency.push({
                                value: element.key,
                                text: element.label,
                            });
                        });
                        resolve(response);
                    }
                })
                .catch((err) => {
                    reject(new Error(err));
                });
        });
    }
    submitFilter() {
        if (this.filter) {
            this.$emit("onFilter", this.filter);
            this.filter = new FilterModel();
            this.hideFilter();
        }
    }
    hideFilter() {
        this.activeShow = false;
    }
    showFilter() {
        this.activeShow = true;
    }
    get activeFilter() {
        if (this.activeShow === true) {
            return "active";
        } else {
            return "";
        }
    }
}
